import { ReviewRequestFormModel } from './types';

export const DEFAULT_FORM_INITIAL_VALUES: ReviewRequestFormModel = {
  userName: '',
  userEmail: '',
};
